import axios from '../../service/index'
import React, { Component } from 'react'
import { connect } from "react-redux"
import { Button, Divider, Table, Modal, Pagination, message, Form, Input, Switch } from 'antd'
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'react-addons-update';
import { component } from "../../commponents/tableRow"
import UploadQiniu from '../../commponents/uploadQiniu/index'
import './knowledge.less'

class Knowledge extends Component {
	state = {
		qiuniuUrl: '',
		showKnowName: false,
		modelTitle: '新增知识点',
		username: '',
		konwledge: '',
		columns: [
			{
				title: '图标',
				dataIndex: 'icon',
				key: 'icon',
				align: 'center',
				render: (record)=> <img src={record} style={{width: '34px',height: '34px'}} alt=""/>
			},	
			{
			title: '知识点',
			dataIndex: 'konwledgeName',
			align: 'center',
			key: 'konwledgeName',
		},
		{
			title: '笔试题数量',
			dataIndex: 'writingTestingNum',
			align: 'center',
			key: 'writingTestingNum',
			render: (record, obj) => {
				return (
					<Button type="link" onClick={() => {
						this.props.backTabButton('1')
						this.props.history.push('/Test', { knowId: obj.id, subjectName: this.state.subjectName, questionId: this.state.questionId })
					}
					}>{record}</Button>
				)
			}
		}, {
			title: '面试题数量',
			dataIndex: 'interviewQuestionsNum',
			align: 'center',
			key: 'interviewQuestionsNum',
			render: (record, obj) => {
				return (
					<Button type="link" onClick={() => {
						this.props.backTabButton('2')
						this.props.history.push('/Test', { knowId: obj.id, subjectName: this.state.subjectName, questionId: this.state.questionId })
					}
					}>{record}</Button>
				)
			}
		}, {
			title: '状态',
			dataIndex: 'status',
			align: 'center',
			key: 'status',
			render: (record, obj) => {
				return (
					<Switch defaultChecked={record === 0 ? true : false} key={record === 0 ? true : false} onChange={(checked) => {
						let id = obj.id
						let arr = this.state.dataSource
						for (let i = 0; i < arr.length; i++) {
							if (id === arr[i].id) {
								arr[i].status = checked === true ? 0 : 1
								this.setState({
									dataSource: arr
								})
							}
						}
						this.topicChange(checked, obj)
					}} />
				)
			}
		}, {
			title: '操作',
			align: 'center',
			key: 'id',
			width: '200px',
			render: (record, data) => {
				return (
					<div className="all-btn">
						<Button type="link" onClick={() => { this.handleKnow(record) }}>编辑</Button>
						<Button type="link" onClick={() => { this.props.history.push('/Test', { knowId: record.id, subjectName: this.state.subjectName, questionId: this.state.questionId }) }}>试题</Button>
						<Button type="link" className="red-color" onClick={() => {
							Modal.confirm({
								title: '删除',
								okText: "确认",
								cancelText: "取消",
								content: '删除后将不可恢复，请谨慎操作！确定要删除吗？',
								onOk: () => {
									this.delStage(record.id)
								},
							});
						}}>删除</Button>
					</div>
				)
			}
		}],
		dataSource: [],
		notChanged: [],
		questionId: '',
		editObj: {},
		subjectName: '',
		total: 0,
		pageNum: 1,
		size: 10
	}
	componentDidMount() {
		let { subjectName, questionId } = this.props.location.state
		this.setState({ subjectName: subjectName, questionId: questionId }, () => {
			this.InitKnow()
		})
		

	}
	InitKnow() {
		let { pageNum, size, questionId, konwledgeName } = this.state
		axios.post('konwledge/list', {
			pageNum, pageSize: size, subjectId: questionId, konwledgeName
		}).then(res => {
			if (res.data.code === '200') {
				let daya = res.data.data
				this.setState({ dataSource: daya.list, notChanged: daya.list, total: daya.total })
			}
		})
	}
	pageChange = (current) => {
		console.log(current)
		this.setState({ pageNum: current }, () => {
			this.InitKnow()
		})

	}
	sizeChange = (current, size) => {
		console.log(current, size)
		this.setState({ pageNum: 1, size: size }, () => {
			this.InitKnow()
		})

	}
	topicChange = (checked, obj) => {
		Modal.confirm({
			title: `${checked ? '发布' : '取消发布'}`,
			content: `${checked ? '确定要发布么？' : '确定要取消发布么？'}`,
			okText: '确定',
			cancelText: '取消',
			onOk: () => {
				axios.post('konwledge/update', { id: obj.id, status: checked ? 0 : 1 }).then(res => {
					if (res.data.code === '200') {
						message.success(`${checked === true ? '发布成功' : `下架成功`}`)
						this.InitKnow()
						Modal.destroyAll();
					} else {
						message.error(res.data.msg)
					}
				})
			},
			onCancel: () => {
				this.InitKnow()
			}
		})
	}
	delStage(id) {
		console.log(id)
		axios.get(`konwledge/delect/${id}`).then(res => {
			if (res.data.code !== '200') return message.error(res.data.msg)
			message.success('删除成功')
			this.InitKnow()
		})
	}
	moveRow = (dragIndex, hoverIndex) => {
		let { dataSource } = this.state
		const dragRow = dataSource[dragIndex];
		this.setState(
			update(this.state, {
				dataSource: {
					$splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
				},
			}),
		);
		let oldSort = []
		for (let i = 0; i < this.state.notChanged.length; i++) {
			oldSort.push({ sort: this.state.notChanged[i].sort, id: this.state.dataSource[i].id })
		}
		axios.post('/konwledge/update/sort', oldSort).then(res => {
			if (res.data.code === '200') {
				oldSort = []
			}
		})
	}
	getQiniuUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
	submitOk = (e) => {
		e.preventDefault()
		this.props.form.validateFields((err, values) => {
			if (!err) {
				let params = { konwledgeName: values.username, subjectId: this.state.questionId }
				delete params.id
				if (this.state.modelTitle === '新增知识点') {
					let icon = this.state.qiuniuUrl + '/' + values.konwledge.response.hash
					params.icon = icon
					axios.post('konwledge/save', params).then(res => {
						if (res.data.code !== '200') return message.error(res.data.msg)
						message.success('新增成功')
						this.InitKnow()
						this.setState({ showKnowName: false })
						this.props.form.resetFields();
					})
				} else {
					let icon = ""
					if(values.konwledge.url){
						icon =  values.konwledge.url
					}else{
						icon = this.state.qiuniuUrl + '/' + values.konwledge.response.hash
					}
					params.icon = icon
					params.id = this.state.editObj.id
					axios.post('konwledge/update', params).then(res => {
						if (res.data.code !== '200') return message.error(res.data.msg)
						message.success('编辑成功')
						this.InitKnow()
						this.setState({ showKnowName: false })
						this.props.form.resetFields();
					})
				}
			}
		})
	}
	handleKnow(name) {
		if (name === 'add') {
			this.setState({ modelTitle: '新增知识点',konwledge: '' })
		} else {
			this.setState({ modelTitle: '编辑知识点', username: name.konwledgeName, editObj: name, konwledge: {
				uid: null,
				type: null,
				url: name.icon,
				name: name.konwledgeName
			} })
		}
		this.setState({ showKnowName: true })
	}
	render() {
		let { dataSource, columns, total, pageNum, subjectName, showKnowName, modelTitle, username, konwledge } = this.state
		const { getFieldDecorator } = this.props.form;
		

		return (
			<div className="know">
				<div className="header-between">
					<span className="header-name">{subjectName}知识点管理</span>
					<span className="my-button-txt" onClick={() => {
						this.props.history.push('/QuestionBank')
					}}>返回上一级</span>
				</div>
				<Divider />
				<div className="search-center">
					<Input placeholder="搜索知识点名称" onChange={(e) => {
						this.setState({ konwledgeName: e.target.value })
					}} />
					<Button className='my-button-primary' type='primary' onClick={() => {
						this.InitKnow()
					}}>搜索</Button>
					<Button className='my-button-primary rig-btn' type='primary' onClick={() => {
						this.handleKnow('add')
					}}>新增知识点</Button>
				</div>
				<DndProvider backend={HTML5Backend}>
					<Table dataSource={dataSource} columns={columns} pagination={false} components={component} rowKey={record => record.id}
						onRow={(record, index) => ({
							index,
							moveRow: this.moveRow,
						})} />
					<Pagination className="table-pagination" total={total} current={pageNum} showSizeChanger showQuickJumper pageSizeOptions={['10', '20', '50', '100']} onChange={this.pageChange} onShowSizeChange={this.sizeChange} />
				</DndProvider>
				<Modal title={modelTitle} maskClosable={false} destroyOnClose visible={showKnowName} onOk={this.submitOk} onCancel={() => { this.setState({ showKnowName: false, konwledge: '' }) }}>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} onSubmit={this.submitOk}>
						<Form.Item label="知识点" name="username">
							{getFieldDecorator('username', {
								rules: [
									{ required: true, message: '请输入知识点' },
									{ max: 20, message: '最多输入20个字!' }
								],
								initialValue: modelTitle === '编辑知识点' ? username : ''
							})(<Input />)}
						</Form.Item>
						<Form.Item label="图标" name="konwledge">
							{getFieldDecorator('konwledge', {
								initialValue: modelTitle === '编辑知识点'? konwledge: '',

								rules: [{ type: 'object', required: true, message: '请上传图标!' }],
							})(
								<UploadQiniu getQiniuUrl={this.getQiniuUrl} />
							)}
						</Form.Item>
					</Form>
				</Modal>
			</div>
		)
	}
}
const mapDispatchToProps = (dispatch) => {
	return {
		backTabButton(num) {
			let action = {
				type: 'tabChange',
				value: num
			}
			dispatch(action)
		}
	}
}
export default Form.create()(connect(null, mapDispatchToProps)(Knowledge))